import React from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
export function RentalItem({
  title,
  description,
  price,
  value,
  onChange,
  disabled = false,
  maxValue = Infinity,
  validationMessage = '',
  priceDisplay = null,
  highlight = false
}) {
  const increment = () => {
    if (value < maxValue) {
      onChange(value + 1);
    }
  };
  const decrement = () => {
    if (value > 0) {
      onChange(value - 1);
    }
  };
  return <div className={`p-4 rounded-md ${highlight ? 'bg-blue-50 border border-blue-300' : 'bg-slate-50'}`} data-id="element-511">
      <div className="flex justify-between" data-id="element-512">
        <div data-id="element-513">
          <h3 className="font-medium text-slate-900" data-id="element-514">{title}</h3>
          <p className="text-sm text-slate-500 mt-1" data-id="element-515">{description}</p>
          {validationMessage && value === maxValue && maxValue > 0 && <p className="text-xs text-red-600 mt-1" data-id="element-516">{validationMessage}</p>}
        </div>
        <div className="text-right" data-id="element-517">
          <div className="font-medium text-slate-900" data-id="element-518">
            {priceDisplay || `$${price.toFixed(2)} per ring`}
          </div>
        </div>
      </div>
      <div className="mt-4 flex items-center" data-id="element-519">
        <button type="button" onClick={decrement} disabled={value === 0} className={`p-1 rounded-full ${value === 0 ? 'text-slate-400 cursor-not-allowed' : 'text-slate-600 hover:bg-slate-200'}`} data-id="element-520">
          <MinusIcon size={20} data-id="element-521" />
        </button>
        <div className="mx-3 w-12 text-center font-medium" data-id="element-522">{value}</div>
        <button type="button" onClick={increment} disabled={disabled || value >= maxValue} className={`p-1 rounded-full ${disabled || value >= maxValue ? 'text-slate-400 cursor-not-allowed' : 'text-slate-600 hover:bg-slate-200'}`} data-id="element-523">
          <PlusIcon size={20} data-id="element-524" />
        </button>
      </div>
    </div>;
}